export default `
    Date: [[date]]
    Status: PAID
    Receipt #: [[billing_id]]

    SELLER
    Name: [[seller_name]]
    Address: [[seller_address]]
    Zip / city: [[seller_zip]], [[seller_city]]
    Country: [[seller_country]]
    P: [[seller_phone]]

    CUSTOMER BILLING
    Name: [[billing_name]]
    Address: [[billing_address]]
    Zip / city: [[billing_zip]], [[billing_city]]
    Country: [[billing_country]]
    P: [[billing_phone]]

    RECEIPT
                            
    Name: [[name]]
    Quantity: [[quantity]]
    Price: [[prefix]][[price]][[suffix]]
    Total: [[prefix]][[total]][[suffix]]
    Participants:

    [[participants]]
                            
    [[thankyou]]

    Total:
    [[prefix]][[total]][[suffix]]
`
